import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import {
  FormGroup,
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator,
} from '../../../components/form/';

import WorkingHours from '../../../components/form/WorkingHours';
import ArtisanBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';
import { currentUserSelector } from '../../../modules/users/Selectors';
import { globalFail } from '../../../modules/globalFail/Selector';
import {
  artisanCategoriesAsLabelAndValueSelector,
  artisanCategoriesIsLoadingSelector,
} from '../../../modules/artisanCategories/Selectors';
import {
  supplierCategoriesAsLabelAndValueSelector,
  supplierCategoriesListSelector,
} from '../../../modules/supplierCategories/Selectors';
import schema from '../TrainingCenter/TrainingCenterSchema';
import Tci18nBlock from '../../../components/form/i18nForm/FormBIOi18n';
import { setRedirectFalse } from '../../../modules/globalFail/Action';
import { getArtisanCategoriesAction } from '../../../modules/artisanCategories/Actions';
import { getSupplierCategoriesAction } from '../../../modules/supplierCategories/Actions';
import { newErrorNotificationAction } from '../../../modules/notifications/Actions';
import {
  createTrainingCenterAction,
  updateTrainingCenterAction,
} from '../../../modules/trainingCenter/Actions';
import setWizardPage from '../../../helpers/setWizardPage';
import { trainingCenterLoading } from '../../../modules/trainingCenter/Selectors';
import getLangData from '../../../utils/getLangData';

const options = [
  {
    value: '0',
    label: 'Blue Collar',
  },
  {
    value: '1',
    label: 'Artisan',
  },
];

const TrainingCenterForm = (props) => {
  const {
    trainingCenterData,
    currentUser,
    artisanCategories,
    supplierCategories,
    getArtisanCategories,
    getSupplierCategories,
    categoriesIsloading,
    errorNotification,
    createTrainingCenter,
    updateTrainingCenter,
    page,
    setPage,
    edit,
    redirectFalse,
    reload,
    fail,
    isLoading
  } = props;

  useEffect(() => {
    getArtisanCategories();
    getSupplierCategories();
  }, []);

  useEffect(() => {
    if (!edit) {
      fail && setWizardPage(page, '8', setPage);
      redirectFalse();
    }
    if (reload) {
      fail && window.location.reload();
    }
  }, [fail]);

  const lang = getLangData().fields
  return (
    <Formik
      enableReinitialize
      initialValues={
        trainingCenterData ? { ...trainingCenterData } : schema().cast()
      }
      validationSchema={schema()}
      onSubmit={(values) => {
        const data = {
          ...values,
          userID: values._id
        }
        if (edit) {
          // true means no redirect
          updateTrainingCenter(values._id, values, true);
          console.log(values)
        } else {
          if (values.profileType[0] === '0' && !values.supplierCID) {
            errorNotification('Please Choose Category');
          } else if (values.profileType[0] === '1' && !values.artisanCID) {
            errorNotification('Please Choose Category');
          } else {
            const { _id } = currentUser;
            createTrainingCenter({ ...values, userID: _id }, true);
            // console.log(values)
          }
        }
      }}
    >
      {({ handleSubmit, values, errors }) => (

        <FormGroup
          errors={errors}
          isLoading={isLoading}
          heading={
            edit ? lang.update_training_form_data : lang.create_training_center
          }
          handleSubmit={handleSubmit}
        >
          <FormSectionTitle>{lang.basic_information} :</FormSectionTitle>
          <InputField name="businessName" label={lang.busience_name} />
          <Tci18nBlock name="businessNamei18n" description="Business Name" />
          <TextArea name="tcBIO" label={lang.training_center_bio} />
          <Tci18nBlock name="tcBIOi18n" description="BIO" />
          <Separator />{' '}
          <Upload
            data={{ userID: currentUser._id }}
            name="logo"
            label={`${lang.profile_logo} :`}
            S3Bucket="warshatna-users"
            // API="customer/customer-category-image-signedurl/"
            API="users/user-profile-image-signedurl"
          />

          <InputField name="yearEstablished" label={lang.year_established} />
          <CheckBox
            name="regCompany"
            label={lang.registered_company}
            subLabel="I have Registered Company."
          />
          <Select
            inArray={true}
            options={options}
            name="profileType"
            label={lang.profile_type}
          />
          {values.profileType[0] === '1' && (
            <SearchableSelect
              isMulti={true}
              options={artisanCategories}
              getItems={getArtisanCategories}
              isLoading={categoriesIsloading}
              name={edit ? 'artisanCategoryData' : 'artisanCID'}
              label={lang.artisan_category}
            />
          )}
          {values.profileType[0] === '0' && (
            <SearchableSelect
              inArray={edit ? true : false}
              isMulti={true}
              options={supplierCategories}
              getItems={getSupplierCategories}
              isLoading={categoriesIsloading}
              name={edit ? 'supplierCategoryData' : 'supplierCID'}
              label={lang.bluecolor_category}
            />
          )}
          {
            // Bio
          }
          <Separator />
          <FormSectionTitle>{lang.contact_person_details}</FormSectionTitle>
          <InputField name="contactPerson" label={lang.contact_person} />
          <InputField name="contactPersonTitle" label={lang.contact_person_title} />
          <InputField name="contactPersonPhone" label={lang.contact_person_phone} />
          <InputField name="contactPersonEmail" label={lang.contact_person_email} />
          <Separator />
          <FormSectionTitle>{lang.social_online}</FormSectionTitle>
          <InputField name="website" label={lang.website} />
          <InputField name="facebook" label={lang.facebook} />
          <InputField name="instagram" label={lang.instagram} />
          <InputField name="youtube" label={lang.youtube} />
          <Separator />
          <FormSectionTitle>{lang.working_hours} :</FormSectionTitle>
          <WorkingHours name="workingHours" />
          {/*   


 */}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => ({
  currentUser: currentUserSelector(state),
  fail: globalFail(state),
  artisanCategories: artisanCategoriesAsLabelAndValueSelector(state),
  supplierCategories: supplierCategoriesListSelector(state),
  categoriesIsloading: artisanCategoriesIsLoadingSelector(state),
  isLoading: trainingCenterLoading(state),
});

const mapDispatchToProps = {
  redirectFalse: setRedirectFalse,
  getArtisanCategories: getArtisanCategoriesAction,
  getSupplierCategories: getSupplierCategoriesAction,
  errorNotification: newErrorNotificationAction,
  createTrainingCenter: createTrainingCenterAction,
  updateTrainingCenter: updateTrainingCenterAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCenterForm);
